import {SET_PROFORMA_INVOICES, UPDATE_PROFORMA_INVOICE} from '../actionTypes';
import {IFarmInputInvoice} from 'constants/interfaces';

export type ProformaInvoiceState = {
  lastUpdate: number;
  invoices: IFarmInputInvoice[];
};
const initialState: ProformaInvoiceState = {lastUpdate: 0, invoices: []};

export default function (
  state = initialState,
  action: {type: string; payload: any},
) {
  switch (action.type) {
    case SET_PROFORMA_INVOICES: {
      const invoices: IFarmInputInvoice[] = action.payload || [];
      const stateUpdate: ProformaInvoiceState = {
        lastUpdate: new Date().getTime(),
        invoices: invoices.map((invoice) => ({...invoice})),
      };
      return stateUpdate;
    }
    case UPDATE_PROFORMA_INVOICE: {
      const updated: IFarmInputInvoice = action.payload;
      if (!updated?.id) return state;
      const invoices = state.invoices.map((inv) =>
        inv.id === updated.id ? {...updated} : {...inv},
      );
      return {
        ...state,
        lastUpdate: new Date().getTime(),
        invoices,
      };
    }

    default:
      return state;
  }
}
